import React from 'react';
import HomePage from './home';

/* 
ExperimentWrapper is a Higher-Order Component that can be used to conditionally wrap your page/component
in order to enable experiments, feature toggles, or A/B testing. 
If you need to enable an experiment for the home page, wrap <HomePage ... /> with <ExperimentWrapper>.
Example:
import ExperimentWrapper from 'path-to-experiment-wrapper';
...
// test variant
<ExperimentWrapper experimentName="my-experiment" defaultValues="" customAttributes={}>
  <HomePage entry={entry} featureFlags={featureFlags} />
</ExperimentWrapper>
// control variant
<ExperimentWrapper invertLogic={true} experimentName="my-experiment" defaultValues="" customAttributes={}>
  <HomePage entry={entry} featureFlags={featureFlags} />
</ExperimentWrapper>
If not required, simply render <HomePage /> as usual.
 */
export default function render(entry, pageTree, featureFlags) {
    return <HomePage entry={entry} featureFlags={featureFlags} />;
}
